import Vue from 'vue'
import VueRouter from 'vue-router'




Vue.use(VueRouter)

// 解决路由跳转报错问题
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}


/**
* constantRoutes
* 没有权限要求的基页
* 所有角色可以访问
*/
export const constantRoutes = [

  {
    path: '/redirect',
    component: () => import("@/views/home/home.vue"),
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/redirect')
      }
    ]
  },
  {
    path: "/",
    component: () => import("../views/home/home.vue"),
    redirect: '/home-page',
    meta: {
      title: '首页'
    },
  },
  {
    path: "/login",
    name: 'login',
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    name: 'Page404',
    meta: { title: '404' }
  },
  {
    // 家长端微信小程序配置业务域名需要的校验文件
    path: '/2JQv0Rq3y5.txt',
    component: () => import('@/wx-text/2JQv0Rq3y5.vue'),
    meta: { title: '2JQv0Rq3y5.txt' }
  },
  {
    // 教师端微信小程序配置业务域名需要的校验文件
    path: '/PMgEtfKbus.txt',
    component: () => import('@/wx-text/PMgEtfKbus.vue'),
    meta: { title: 'PMgEtfKbus.txt' }
  },
  {
    path: '/userinfo-add',
    name: 'userinfo-add',
    component: () => import('@/views/userinfo-add/userinfoAdd.vue'),
  },
  {
    path: '/home-page',
    name: 'home-page',
    component: () => import('@/views/home-page/homePage.vue'),
  },
  {
    path: "/",
    component: () => import("../views/home/home.vue"),
    // redirect: '/home-page',
    // path: "/welcome",
    meta: {
      title: '首页'
    },
    children: [
      // {
      //   path: "/home-page",
      //   // path: "/welcome",
      //   // component: () => import("../views/welcome/welcome.vue"),
      //   component: () => import('@/views/home-page/homePage.vue'),
      //   meta: {
      //     title: '首页',
      //   },
      // },
      {
        path: "/admin-curriculum",
        component: () => import("../views/admin-curriculum/curriculum.vue"),
        meta: {
          title: '课程编排',
        },
      },
      // {
      //   path: "/timetable",
      //   component: () => import("../views/timetable/timetable.vue"),
      //   meta: {
      //     title: '课程表',
      //   },
      // },
      // {
      //   path: "/admin-achievement",
      //   component: () => import("@/views/admin-achievement/achievement.vue"),
      //   meta: {
      //     title: '考试信息',
      //     // roles: []
      //   },
      // },
      {
        path: "/achievement-analysis-grade",
        component: () => import("@/views/achievement-analysis-grade/achievementAnalysisGrade.vue"),
        meta: {
          title: '考试信息-年级',
          // roles: []
        },
      },
      {
        path: "/achievement-analysis-class",
        component: () => import("@/views/achievement-analysis-class/achievementAnalysisClass.vue"),
        meta: {
          title: '考试信息-班级',
          // roles: []
        },
      },
      {
        path: "/achievement-comparison",
        component: () => import("@/views/achievement-comparison/achievementComparison.vue"),
        meta: {
          title: '学生成绩对比',
          // roles: []
        },
      },
      {
        path: "/achievement-student-rank",
        component: () => import("@/views/achievement-student-rank/achievementStudentRank.vue"),
        meta: {
          title: '学生成绩排行',
          // roles: []
        },
      },
      {
        path: "/achievement-analysis",
        component: () => import("@/views/achievement-analysis/achievementAnalysis.vue"),
        meta: {
          title: '成绩分析',
          // roles: []
        },
      },
      {
        path: "/achievement-external",
        component: () => import("@/views/achievement-external/achievementExternal.vue"),
        meta: {
          title: '校外成绩',
          // roles: []
        },
      },
      {
        path: "/achievement-student-tag",
        component: () => import("@/views/achievement-student-tag/achievementStudentTag.vue"),
        meta: {
          title: '学生标签',
          // roles: []
        },
      },
      {
        path: "/achievement-multiple-score",
        component: () => import("../views/achievement-multiple-score/achievementMultipleScore.vue"),
        meta: {
          title: '学生多次考试成绩',
        },
      },
      // {
      //   path: "/achievement",
      //   component: () => import("../views/achievement/achievement.vue"),
      //   meta: {
      //     title: '学生成绩',
      //     // roles: []
      //   },
      // },
      // {
      //   path: "/studentInfo",
      //   component: () => import("../views/studentinfo/studentInfo.vue"),
      //   meta: {
      //     title: '学生信息',
      //   },
      // },
      {
        path: "/userInfo",
        component: () => import("../views/userinfo/userInfo.vue"),
        meta: {
          title: '用户信息',
          identification: 'userInfo'
        },
      },
      // {
      //   path: "/bind-class",
      //   component: () => import("@/views/bind-class/bindClass.vue"),
      //   meta: {
      //     title: '绑定班级',
      //   },
      // },
      {
        path: "/revisephone",
        meta: {
          title: '修改手机号',
        },
        component: () => import("@/views/revisenumber/reviseNumber"),
      },
      {
        path: "/revise-password",
        meta: {
          title: '修改密码',
        },
        component: () => import("@/views/revise-password/revisePassword"),
      },
      {
        path: "/admin-grade",
        component: () => import("@/views/admin-grademanagement/gradeManagement"),
        meta: {
          title: "年级管理",
        }
      },
      {
        path: "/admin-schoolinfo",
        meta: {
          title: '学校信息',
        },
        component: () => import("@/views/admin-schoolinfo/schoolinfo"),
      },
      {
        path: "/admin-classroom",
        meta: {
          title: '课室管理',
        },
        component: () => import("@/views/admin-classroom/classroom"),
      },

      {
        path: "/admin-teacher",
        meta: {
          title: '教师管理',
        },
        component: () => import("@/views/admin-teacher/teacher"),
      },
      {
        path: "/admin-course",
        meta: {
          title: '科目管理',
        },
        component: () => import("@/views/admin-course/course"),
      },
      // {
      //   path: "/admin-beacon",
      //   meta: {
      //     title: '信标管理',
      //   },
      //   component: () => import("@/views/admin-beacon/beacon"),
      // },
      // {
      //   path: "/achievement-class",
      //   meta: {
      //     title: '班级成绩',
      //   },
      //   component: () => import("@/views/achievement-class/achievementClass"),
      // },
      {
        path: "/achievement-student",
        meta: {
          title: '学生成绩详情',
        },
        component: () => import("@/views/achievement-student/achievementStudent"),
      },
      {
        path: "/notice",
        meta: {
          title: '学校公告',
        },
        component: () => import("@/views/notice/notice"),
      },
      {
        path: "/notice-detail",
        meta: {
          title: '公告详情',
        },
        component: () => import("@/views/notice-detail/noticeDetail"),
      },

      {
        path: '/device-manage',
        meta: {
          title: '学生卡管理',
        },
        component: () => import('@/views/admin-device-manage/deviceManage.vue'),
      },
      {
        path: '/homework-list',
        name: 'homework-list',
        meta: {
          title: '作业列表',
        },
        component: () => import('@/views/homework-list/homeworkList.vue'),
      },
      {
        path: '/completed-homework-list',
        name: 'completed-homework-list',
        meta: {
          title: '已完成作业列表',
        },
        component: () => import('@/views/completed-homework-list/completedHomeworkList.vue')
      },
      {
        path: '/publish-homework',
        name: 'publish-homework',
        meta: {
          title: '发布作业',
        },
        component: () => import('@/views/publish-homework/publishHomework.vue'),
      },
      {
        path: '/leave',
        name: 'leave',
        meta: {
          title: '请假列表', 
        },
        component: () => import('@/views/leave/leave.vue'),
      },
      {
        path: '/examine',
        meta: {
          title: '公告审核',
        },
        component: () => import('@/views/admin-examine/examine.vue')
      },
      // {
      //   path: '/teacherExamine',
      //   meta: {
      //     title: '审核结果',
      //   },
      //   component: () => import('@/views/teacher-examine/teacherExamine.vue')
      // },
      {
        path: '/sensitiveWord',
        meta: {
          title: '敏感词信息',
        },
        component: () => import('@/views/sensitive-word/sensitiveWord.vue')
      },
      // {
      //   path: '/no-disturb',
      //   name: 'no-disturb',
      //   meta: {
      //     title: '免打扰',
      //   },
      //   component: () => import('@/views/no-disturb/noDisturb.vue'),
      // },
      {
        path: '/admin-noDisturb',
        name: 'no-disturb',
        meta: {
          title: '免打扰',
        },
        component: () => import('../views/admin-noDisturb/noDisturb.vue'),
      },
      {
        path: '/attendance-class',
        name: 'attendance-class',
        meta: {
          title: '考勤管理',
        },
        component: () => import('@/views/attendance-class/attendance-class.vue'),
      }, {
        path: "/admin-studentinfo",
        component: () => import("../views/admin-studentinfo/studentInfo.vue"),
        meta: {
          title: '学生信息',
        },
      },
      {
        path: "/admin-dormitory",
        component: () => import("../views/admin-dormitory/dormitory.vue"),
        meta: {
          title: '宿舍管理',
        },
      },
      {
        path: "/admin-studentDorm",
        component: () => import("../views/admin-studentDorm/studentDorm.vue"),
        meta: {
          title: '宿舍学生添加',
        },
      },
      {
        path: "/admin-teacher-group",
        component: () => import("../views/admin-teacher-group/teacherGroup.vue"),
        meta: {
          title: '教师分组',
        },
      },
      {
        path: "/standard-setting",
        component: () => import("../views/standard-setting/standardSetting.vue"),
        meta: {
          title: '标准制定',
        },
      },
      {
        path: "/teacher-evaluation-result",
        component: () => import("../views/teacher-evaluation-result/teacherEvaluationResult.vue"),
        meta: {
          title: '评定结果',
        },
      },
      {
        path: "/evaluation-management",
        component: () => import("../views/evaluation-management/evaluationManagement.vue"),
        meta: {
          title: '评定管理',
        },
      },
      {
        path: "/admin-menumanagement",
        component: () => import("../views/admin-menumanagement/menuManagement.vue"),
        meta: {
          title: '菜单管理',
        },
      },
      {
        path: "/admin-jobmanagement",
        component: () => import("../views/admin-jobmanagement/jobManagement.vue"),
        meta: {
          title: '职务管理',
        },
      },
      {
        path: "/admin-duty-arrangement",
        component: () => import("../views/admin-duty-arrangement/dutyArrangement.vue"),
        meta: {
          title: '值日编排',
        },
      },
      {
        path: "/admin-duty-type",
        component: () => import("../views/admin-duty-type/dutyType.vue"),
        meta: {
          title: '值日类型',
        },
      },
      // {
      //   path: "/duty-arrangement",
      //   component: () => import("../views/duty-arrangement/dutyArrangement.vue"),
      //   meta: {
      //     title: '值日表',
      //   },
      // },
      // {
      //   path: "/course-djustment",
      //   component: () => import("../views/course-djustment/courseDjustment.vue"),
      //   meta: {
      //     title: '调课申请',
      //   },
      // },
      {
        path: "/admin-courseDjustment",
        component: () => import("../views/admin-courseDjustment/courseDjustment.vue"),
        meta: {
          title: '调课审核',
        },
      },
      {
        path: "/awards",
        component: () => import("../views/awards/awards.vue"),
        meta: {
          title: '获奖情况',
        },
      },
      {
        path: "/admin-publicvenue",
        component: () => import("../views/admin-publicvenue/publicvenue.vue"),
        meta: {
          title: '场馆管理',
        },
      },
      // {
      //   path: "/admin-venueAppointment",
      //   component: () => import("../views/admin-venueAppointment/venueAppointment.vue"),
      //   meta: {
      //     title: '场馆预约',
      //   },
      // },
      {
        path: "/venueAppointment",
        component: () => import("../views/venueAppointment/venueAppointment.vue"),
        meta: {
          title: '场馆预约',
        },
      },
      {
        path: "/practicalActivity",
        component: () => import("../views/practical-activity/practicalActivity.vue"),
        meta: {
          title: '实践活动',
        },
      },
      {
        path: "/activity-score-entry",
        component: () => import("../views/practical-activity-score-entry/activityScoreEntry.vue"),
        meta: {
          title: '实践活动成绩录入',
        },
      },
      {
        path: "/elective-score-entry",
        component: () => import("../views/elective-score-entry/electiveScoreEntry.vue"),
        meta: {
          title: '选修成绩',
        },
      },
      {
        path: "/audit-type",
        component: () => import("../views/audit-type/auditType.vue"),
        meta: {
          title: '审核类型',
        },
      },
      {
        path: "/admin-course-schedule",
        component: () => import("../views/admin-course-schedule/courseSchedule.vue"),
        meta: {
          title: '课程计划',
        },
      },
      {
        path: "/survey-table",
        component: () => import("../views/survey-table/surveyTable.vue"),
        meta: {
          title: '调查统计',
        },
      },
      {
        path: "/survey-table-detail",
        component: () => import("../views/survey-table-detail/surveyTableDetail.vue"),
        meta: {
          title: '调查统计详情',
        },
      },
      {
        path: "/admin-stationery",
        component: () => import("../views/admin-stationery/stationery.vue"),
        meta: {
          title: '文具管理',
        },
      },
      {
        path: "/stationery-record",
        component: () => import("../views/stationery-record/stationeryRecord.vue"),
        meta: {
          title: '文具申请',
        },
      },
      {
        path: "/student-tutor",
        component: () => import("../views/student-tutor/studentTutor.vue"),
        meta: {
          title: '学生导师',
        },
      },
      {
        path: "/student-record-statistics",
        component: () => import("../views/student-record-statistics/studentRecordStatistics.vue"),
        meta: {
          title: '学生记录统计',
        },
      },
      {
        path: "/student-record-detail",
        component: () => import("../views/student-record-detail/studentRecordDetail.vue"),
        meta: {
          title: '学生记录详情',
        },
      },
      {
        path: "/online-interaction",
        component: () => import("../views/online-interaction/onlineInteraction.vue"),
        meta: {
          title: '在线互动',
        },
      }
    ]
  },
]

/**
 * 异步路由
 *需要根据用户角色动态加载的路由
 * roles: [] 存放可访问的角色 1：管理员 21：班主任(有科目) 20：班主任(无科目) 31：科任老师(有科目) 30：科任老师(无科目)
 */
export const asyncRoutes = [
  // 404页必须放在末尾！！！
  { path: '*', redirect: '/404', hidden: true },

]

const createRouter = () => new VueRouter({
  mode: 'history', // require service support
  // base: '/pc/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()


export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重置路由
}


export default router
